/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioBasicDetails } from './InternalApiScenarioBasicDetails';
import {
    InternalApiScenarioBasicDetailsFromJSON,
    InternalApiScenarioBasicDetailsFromJSONTyped,
    InternalApiScenarioBasicDetailsToJSON,
    InternalApiScenarioBasicDetailsToJSONTyped,
} from './InternalApiScenarioBasicDetails';

/**
 * 
 * @export
 * @interface InternalScenariosBasicPage
 */
export interface InternalScenariosBasicPage {
    /**
     * 
     * @type {number}
     * @memberof InternalScenariosBasicPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalScenariosBasicPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalScenariosBasicPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiScenarioBasicDetails>}
     * @memberof InternalScenariosBasicPage
     */
    content: Array<InternalApiScenarioBasicDetails>;
}

/**
 * Check if a given object implements the InternalScenariosBasicPage interface.
 */
export function instanceOfInternalScenariosBasicPage(value: object): value is InternalScenariosBasicPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalScenariosBasicPageFromJSON(json: any): InternalScenariosBasicPage {
    return InternalScenariosBasicPageFromJSONTyped(json, false);
}

export function InternalScenariosBasicPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalScenariosBasicPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiScenarioBasicDetailsFromJSON)),
    };
}

export function InternalScenariosBasicPageToJSON(json: any): InternalScenariosBasicPage {
    return InternalScenariosBasicPageToJSONTyped(json, false);
}

export function InternalScenariosBasicPageToJSONTyped(value?: InternalScenariosBasicPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiScenarioBasicDetailsToJSON)),
    };
}

